module.exports = __webpack_public_path__ + "img/data_privacy.49af4c96.svg";